import { Box, Stack, Typography, Link } from "@mui/material";
import { dashboardDetailsStyles } from "./dashboardDetailsContainer.styles";
import smaartLogo from "../../assets/images/logo_smaart_green.png";

const dashboardTexts = [
  { title: "Stato", text: "Attivo" },
  {
    title: "Periodo di riferimento",
    text: "Maggio 2024 - Aprile 2027",
  },
  {
    title: "Finanziatore",
    text: "Accordi Innovazione - MIMIT - Ministero delle Imprese e del Made in Italy",
  },
  { title: "Coordinatore del progetto", text: "Abinsula" },
  { title: "Sito web", text: "https://progettosmaart.eu/" },
];

const DashboardDetails = () => {
  return (
    <Box sx={dashboardDetailsStyles.container}>
      <Box sx={dashboardDetailsStyles.logo}>
        <img alt="smaart-img" src={smaartLogo} style={{ maxHeight: "100%" }} />
      </Box>
      {dashboardTexts.map(({ title, text }) => (
        <Stack
          direction="column"
          spacing={0.5}
          sx={dashboardDetailsStyles.textRow}
          key={title}
        >
          <Typography fontWeight="bold" fontSize="12px">
            {`${title}:`}
          </Typography>
          {title === "Sito web" ? (
            <Link
              href={text}
              target="_blank"
              rel="noopener noreferrer"
              fontSize="12px"
              underline="hover"
            >
              {text}
            </Link>
          ) : (
            <Typography fontSize="12px">{text}</Typography>
          )}
        </Stack>
      ))}
    </Box>
  );
};

export default DashboardDetails;
